export interface IUser {
	id: number;
	nameID: string;
	firstName: string;
	lastName: string;
	email: string;
	displayName: string;
	username: string;
	role: string;
	phone: string;
	groups: string[];
	permissions: string[];
}

export const birthCountryId = 112; //Israel
export const countryId = 112; //Israel
